import { FAVOURITES, FAVOURITES_LABEL } from './Favourites'

/**
 * Name of all cars together, as in a race without groups
 * @type {string}
 */
export const ALL_CARS_LABEL = 'All cars'

/**
 * Get the name of a group: numbered groups are prefixed with 'Group', others keep their key
 * @param {number|string} group group key
 * @returns {string} group name
 */
export const getGroupName = ( group = '' ) =>
{
  if ( group === FAVOURITES ) return FAVOURITES_LABEL
  if ( !isNaN( parseInt( group ) ) ) return `Group ${ group }`
  return String( group )
}
